import { MENU_JIAMENG_NEW_CUSTOMER, JIAMENG_CUSTOMER_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_NEW_CUSTOMER,
  id: '',
  title: '客户',
  icon: 'icon-kezi',
  link: JIAMENG_CUSTOMER_PATH
}
